/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCompanyRoles200ResponseRolesInner
 */
export interface GetCompanyRoles200ResponseRolesInner {
    /**
     * `権限コード`
     * @type {string}
     * @memberof GetCompanyRoles200ResponseRolesInner
     */
    roleCode: string;
    /**
     * `権限名`
     * @type {string}
     * @memberof GetCompanyRoles200ResponseRolesInner
     */
    roleName: string;
    /**
     * `管理者ステータス true:管理者 false:一般`
     * @type {boolean}
     * @memberof GetCompanyRoles200ResponseRolesInner
     */
    isAdministrator: boolean;
    /**
     * プランバージョン
     * @type {number}
     * @memberof GetCompanyRoles200ResponseRolesInner
     */
    version?: number;
    /**
     * ロールカテゴリ 1:全般 2:ダイレクト
     * @type {number}
     * @memberof GetCompanyRoles200ResponseRolesInner
     */
    roleCategory?: number;
}

/**
 * Check if a given object implements the GetCompanyRoles200ResponseRolesInner interface.
 */
export function instanceOfGetCompanyRoles200ResponseRolesInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "roleCode" in value;
    isInstance = isInstance && "roleName" in value;
    isInstance = isInstance && "isAdministrator" in value;

    return isInstance;
}

export function GetCompanyRoles200ResponseRolesInnerFromJSON(json: any): GetCompanyRoles200ResponseRolesInner {
    return GetCompanyRoles200ResponseRolesInnerFromJSONTyped(json, false);
}

export function GetCompanyRoles200ResponseRolesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompanyRoles200ResponseRolesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'roleCode': json['role_code'],
        'roleName': json['role_name'],
        'isAdministrator': json['is_administrator'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'roleCategory': !exists(json, 'role_category') ? undefined : json['role_category'],
    };
}

export function GetCompanyRoles200ResponseRolesInnerToJSON(value?: GetCompanyRoles200ResponseRolesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'role_code': value.roleCode,
        'role_name': value.roleName,
        'is_administrator': value.isAdministrator,
        'version': value.version,
        'role_category': value.roleCategory,
    };
}

